import React, { useEffect, useState } from 'react'
import { CommonModal, Loader, NavigateBack, Tooltip } from '../../components'
import { Heading } from '../appSettings/AppSettingsStyles'
import { Notify, Utils } from '../../utils'
import Button from '../../components/customButton/Button'
import { useNavigate } from 'react-router-dom'
import { IRASTable } from '../filing/CPFFilingStyles'
import { TableHeader } from '../../components/table'
import { TableRow } from '../payslip/PayslipStyles'
import moment from 'moment'
import { ServiceCodeService } from '../../_service'
import { Constant } from '../../config'
import { LoaderContainer } from '../../CommonStyles'
import { FilterByChar } from '../dashboard/component'
import SearchByColumn from '../../components/SearchByColumn' // Import the new component
import { Archive } from '@mui/icons-material'
import { Toolbar } from '@mui/material'

const RepeatedInvoice = () => {
    const navigate = useNavigate();
    const [repeatedInvoiceData, setRepeatedInvoiceData] = useState([])
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filteredRepeatedInvoices, setFilteredRepeatedInvoices] = useState([])
    const [char, setChar] = useState("All");
    const [showArchiveModal, setShowArchiveModal] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);

    const confirmArchive = (id: number) => {
        setSelectedId(id);
        setShowArchiveModal(true);
    };

    const handleConfirmArchive = async () => {
        if (selectedId != null) {
            await handleArchive(selectedId);
            setShowArchiveModal(false);
            setSelectedId(null);
        }
    };


    const getRepeatInvoiceList = async () => {
        setIsLoading(() => true);
        try {
            const { data, status } = await ServiceCodeService._getRepeatInvoiceList("");
            if (status === 200) {
                setRepeatedInvoiceData(data?.data);
                setFilteredRepeatedInvoices(data?.data);
            }
        } catch (error) {
            Notify(Constant.common.something_went_wrong, 0);
        }
        setIsLoading(() => false);
    }

    useEffect(() => {
        getRepeatInvoiceList()
    }, [])

    const handleArchive = async (id: any) => {
        try {
            const { status } = await ServiceCodeService._archiveRepeatInvoice(id);
            if (status === 200) {
                Notify("Repeated Invoice archived successfully!", 1);
                getRepeatInvoiceList();
            } else {
                Notify(Constant.common.something_went_wrong, 0);
            }
        } catch (error) {
            Notify(Constant.common.something_went_wrong, 0);
        }
    };


    // Table headers
    const repeateInvoiceHeaders = [
        { name: "Unique Id", width: "7%" },
        { name: "Name", width: "15%" },
        { name: "SPC", width: "6%" },
        { name: "Reference", width: "15%" },
        { name: "Amount", width: "10%", textAlign: "center" as "center" },
        { name: "Repeating", width: "10%" },
        { name: "Date Created", width: "10%" },
        { name: "Next Invoice Date", width: "11%" },
        { name: "End Date", width: "8%" },
        { name: "Invoice Will Be", width: "10%" },
        { name: "Archive", width: "7%" },
    ];

    const handleDataUpdateByChar = async (props: string) => {
        setChar(props);

        // Reset filtered list to original data when character filter is used
        if (props === "All") {
            setFilteredRepeatedInvoices(repeatedInvoiceData);
        } else {
            const updated = repeatedInvoiceData.filter((item: any) => {
                const name = item?.company_data?.company_details?.name ?? "";
                return name.toLowerCase().startsWith(props.toLowerCase());
            });
            setFilteredRepeatedInvoices(updated);
        }
    };


    // Transform data for SearchByColumn

    const transformedData = repeatedInvoiceData.map((item: any) => ({
        ...item,
        company_name: item?.company_data?.company_details?.name || "",
        spc_code: item?.company_data?.spc_details?.spc_code || "",
        amount: item?.json_data?.sub_total || 0,
        created_date: Utils.FormatDateDDMMYYYY(item.created_at) || "",
        next_invoice_date: Utils.FormatDateDDMMYYYY(item.next_invoice_date) || "",
        end_date: Utils.FormatDateDDMMYYYY(item?.end_date) || ""
    }));

    console.log(transformedData, "transformedData");


    const filteredByChar = filteredRepeatedInvoices.filter((item) => {
        const name = item?.company_data?.company_details?.name ?? "";
        if (!name) return false;

        return char === "All" || name.toLowerCase().startsWith(char.toLowerCase());
    });

    return (
        <div>
            {isLoading ? (
                <LoaderContainer>
                    <Loader />
                </LoaderContainer>
            ) : (
                <div>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "0.5rem",
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <NavigateBack />
                            <Heading>{("Repeated Invoice Listing")}</Heading>
                        </div>
                        <div>
                            <Button onClick={() => navigate("/dashboard/manage_invoicing/repeatedinvoice/addrepeatedinvoice")} title='New Repeating Invoice' />
                        </div>
                    </div>

                    <div style={{ marginTop: '1rem' }}>
                        <SearchByColumn
                            options={[
                                { label: "Company Name", value: "company_name" },
                                { label: "SPC Code", value: "spc_code", isOnlyFilterFromStart: true },
                                { label: "Reference", value: "reference" },
                                { label: "Amount", value: "amount" },
                                { label: "Created Date", value: "created_date" },
                                { label: "Next Invoice Date", value: "next_invoice_date" },
                                { label: "End Date", value: "end_date" },
                            ]}
                            data={transformedData}
                            onFiltered={(list) => {
                                //   back to original format if needed
                                const originalFormatList = list.map(item => {
                                    // Find the original item in repeatedInvoiceData
                                    return repeatedInvoiceData.find(
                                        (original: any) => original.id === item.id
                                    ) || item;
                                });
                                setChar("All");
                                setFilteredRepeatedInvoices(originalFormatList);
                            }}
                            placeholder="Search repeated invoices..."
                        />
                    </div>

                    <FilterByChar value={char} onChange={handleDataUpdateByChar} />

                    <IRASTable style={{ width: "100%" }}>
                        <TableHeader
                            headerColumns={repeateInvoiceHeaders}
                            variant="filled"
                            styles={{ padding: "5px" }}
                            textAlign="left"
                        />
                        <tbody>
                            {filteredByChar.length === 0 ? (
                                <tr>
                                    <td colSpan={9} style={{ textAlign: "center", padding: "1rem" }}>
                                        No results found.
                                    </td>
                                </tr>
                            ) : (
                                filteredByChar.map((item: any) => (
                                    <TableRow
                                        key={item.id}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: item.archived ? '#f2f2f2' : '' // Light gray for archived
                                        }} onClick={() => navigate('addrepeatedinvoice', { state: { ...item, isEdit: true } })}
                                    >

                                        {/* {uniqe id} */}
                                        <td style={{ padding: '0.5rem' }}>
                                            <span className="spc-badge">
                                                {item?.unique_id}
                                            </span>
                                        </td>

                                        {/* Name */}
                                        <td
                                            style={{
                                                padding: "0.5rem",
                                                color: "#0000FF",
                                                cursor: "pointer",
                                                textDecoration: "none",
                                            }}
                                            onMouseEnter={(e: any) => (e.target.style.textDecoration = "underline")}
                                            onMouseLeave={(e: any) => (e.target.style.textDecoration = "none")}
                                        >
                                            {item?.company_data?.company_details?.name || ""}
                                        </td>

                                        {/* SPC */}
                                        <td style={{ padding: '0.5rem' }}>
                                            <span className="spc-badge">
                                                {item?.company_data?.spc_details?.spc_code}
                                            </span>
                                        </td>

                                        {/* Reference */}
                                        <td style={{ padding: '0.5rem' }}>
                                            {item.reference || "-"}
                                        </td>

                                        {/* Amount */}
                                        <td style={{ padding: '0.5rem', textAlign: "right", paddingRight: "3%" }}>
                                            {item?.company_data?.billing_details?.currency_details?.symbol}
                                            {Utils.getCommanSepartedNumericString(item?.json_data?.sub_total) || ""}
                                        </td>

                                        {/* Repeat */}
                                        <td style={{ padding: '0.5rem' }}>
                                            {item.recurrence_text || "-"}
                                        </td>

                                        {/* Created Date */}
                                        <td style={{ padding: '0.5rem' }}>
                                            {Utils.FormatDateDDMMYYYY(item.created_at) || "-"}
                                        </td>

                                        {/* Next Invoice Date */}
                                        <td style={{ padding: '0.5rem' }}>
                                            {Utils.FormatDateDDMMYYYY(item.next_invoice_date) || "-"}
                                        </td>

                                        {/* End Date */}
                                        <td style={{ padding: '0.5rem' }}>
                                            {Utils.FormatDateDDMMYYYY(item?.end_date) || "-"}
                                        </td>

                                        {/* Status */}
                                        <td style={{ padding: '0.5rem', color: "green" }}>
                                            saved as draft
                                        </td>
                                        <td style={{ padding: '0.5rem', display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                            {item.archived ? (
                                                <span style={{ color: '#e74c3c' , fontWeight : 600 }}>Archived</span>
                                            ) : (
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        confirmArchive(item.id);
                                                    }}
                                                    style={{
                                                        background: 'transparent',
                                                        border: 'none',
                                                        padding: '4px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <Tooltip twolinetext={false} text="Archive" >
                                                        <p
                                                            style={{
                                                                padding: "0.25rem 0.75rem",
                                                                background:
                                                                    item?.status === "preview" ? "#059BBF" : "#03B381",
                                                                cursor: "pointer",
                                                                color: "white",
                                                                fontWeight: 400,
                                                                borderRadius: "0.25rem",
                                                            }}>Active</p>
                                                    </Tooltip>

                                                </button>
                                            )}
                                        </td>


                                    </TableRow>
                                ))
                            )}
                        </tbody>
                    </IRASTable>

                </div>
            )}
            <CommonModal
                open={showArchiveModal}
                handleClose={() => setShowArchiveModal(false)}
                updateData={handleConfirmArchive}
                heading="Archive Repeated Invoice"
                body="Are you sure you want to archive this Repeated invoice?"
                conformButtonText="Yes, Archive"
                cancelButtonText="Cancel"
            />

        </div>
    )
}

export default RepeatedInvoice